import { createSlice } from '@reduxjs/toolkit';
import {
  handleResetFilter,
  handleSetSelectedItems,
  handleSetSelectedFilterIds,
  handleToggleCollapsed,
  handleSetSelectedSentimentValues,
  handleChangeSortBy,
  handleSetSelectedFilterValue,
} from 'store/helpers/filterHelpers';
import { handleApplySettingsFilters } from './contentHelpers';
import { instagramCommentFiltersInitialState } from './initialState/instagramCommentByPostInitialState';

export { instagramCommentFiltersInitialState as filtersInitialState };
export const instagramCommentByPostContentInitialState = {
  filters: instagramCommentFiltersInitialState,
  sortBy: {
    selected: 'time',
    order: 'desc',
  },
  selectedFilter: 'contentTagFilter',
};
export const instagramCommentByPostContentSlice = createSlice({
  name: 'instagramCommentByPostContentSlice',
  initialState: instagramCommentByPostContentInitialState,
  reducers: {
    setSelectedFilterIds: (state, action) => {
      handleSetSelectedFilterIds(state, action);
    },
    setSelectedItems: (state, action) => {
      handleSetSelectedItems(state, action);
    },
    setSelectedSentimentValues: (state, action) => {
      handleSetSelectedSentimentValues(state, action);
    },
    setSelectedFilterValue: (state, action) => {
      handleSetSelectedFilterValue(
        state,
        action,
        instagramCommentFiltersInitialState
      );
    },
    changeSortBy: (state, action) => {
      handleChangeSortBy(state, action);
    },
    toggleCollapsed: (state, action) => {
      handleToggleCollapsed(state, action);
    },
    resetAllFilters: (state) => {
      state.filters = instagramCommentFiltersInitialState;
    },
    resetFilter: (state, action) => {
      handleResetFilter(state, action, instagramCommentFiltersInitialState);
    },
    applyWebsiteSettingsFilters: (state, action) => {
      handleApplySettingsFilters(state, action);
    },
    setSelectedFilter: (state, action) => {
      state.selectedFilter = action.payload;
    },
  },
});

export const {
  setSelectedFilterIds,
  setSelectedItems,
  toggleCollapsed,
  resetAllFilters,
  resetFilter,
  setSelectedSentimentValues,
  changeSortBy,
  setSelectedFilterValue,
  applyWebsiteSettingsFilters,
  setSelectedFilter,
} = instagramCommentByPostContentSlice.actions;
